import axios from 'axios';

export const setBetPlaced = async (outcome_id_normalized, email, value=null) => {
	const accessToken = window.localStorage.getItem('access_token');

	if (!value) {
		const res = await axios.post(
			`${process.env.REACT_APP_BACKEND_URL}/set_placed_bets?outcome_id_normalized=${outcome_id_normalized}&email=${email}`,
			{},
			{
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			}
		);
	
		return res.data;
	} else {
		const res = await axios.post(
			`${process.env.REACT_APP_BACKEND_URL}/set_placed_bets?outcome_id_normalized=${outcome_id_normalized}&email=${email}&value=${value}`,
			{},
			{
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			}
		);
	
		return res.data;
	}
	
};

export const removeBetPlaced = async (outcome_id_normalized, email) => {
	const accessToken = window.localStorage.getItem('access_token');

	const res = await axios.post(
		`${process.env.REACT_APP_BACKEND_URL}/remove_placed_bets?outcome_id_normalized=${outcome_id_normalized}&email=${email}`,
		{},
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		}
	);

	return res.data;
};

